module.exports = __webpack_public_path__ + "media/images/offline-a6e3ee0aa5ae3bc9b9aaea7473f73023.png";